<div class="t-xx bold dark-gray empty-d-n theme-title-color" v-if="module.content.enabled"><template v-if="content">{{ content.text }}</template></div>